var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "12px",
    viewBox: "0 0 21 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kepler-icon-0408",
    transform: "translate(-32.000000, -893.000000)",
    fill: "#E07D26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8154362,893 C34.6036673,893 32,895.686471 32,899.00001 C32,902.31355 34.6038284,905 37.8154362,905 C41.0269634,905 43.6308723,902.313777 43.6308723,899.00001 C43.6308723,895.686223 41.0272856,893 37.8154362,893 Z M47.1023615,893.351522 C45.4963965,893.351522 44.1948348,895.881029 44.1948348,899.000093 C44.1948348,902.119136 45.4966382,904.648891 47.1025226,904.648891 C48.7084876,904.648891 50.0102709,902.119363 50.0102709,899.000093 L50.0100293,899.000093 C50.0100293,895.880142 48.7084876,893.351522 47.1024421,893.351522 L47.1023615,893.351522 Z M51.5970458,893.939819 C51.0323585,893.939819 50.5745757,896.205541 50.5745757,899.000093 C50.5745757,901.794624 51.0320363,904.060346 51.5970458,904.060346 C52.1619748,904.060346 52.6197576,901.794067 52.6197576,899.00001 C52.6197576,896.205376 52.1618137,893.939819 51.5970458,893.939819 Z",
    id: "medium"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumActive);
export default __webpack_public_path__ + "static/media/medium_active.8105aa34141d359d98a11895b61baf6f.svg";
export { ForwardRef as ReactComponent };